import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {getCountries, getInterviewbyid, postResponse} from '../_requets'
import {useAuth} from '../../../modules/auth'
import Swal from 'sweetalert2'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.css'
import {RootState} from '../../../redux/store'
import {useSelector, useDispatch} from 'react-redux'
import {setCountries} from '../../../redux/utils/countrySlice'
import PlacesAutocomplete, {geocodeByAddress, getLatLng} from 'react-places-autocomplete'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {GoogleMap, Marker} from '@react-google-maps/api'
import {Button, Modal, Spinner} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {parseBold, removeAsterisk} from '../../../utils/parseText'
import {TbParkingCircleFilled} from 'react-icons/tb'
import {BsFuelPumpFill} from 'react-icons/bs'

interface QuestionData {
  title?: string
  titleId?: string
  questionId?: string
  question: string
  type: string
  order: number
  required: boolean
  other: boolean
  comment: boolean
  options: string[]
  reason: boolean
  reasonTitle?: string
  reasonId?: string
  reasonType?: string
  reasonOptions?: string[]
  checkpointId?: string
}

interface InterviewQuestion extends Omit<QuestionData, 'options' | 'reasonOptions' | 'comment'> {
  response: any[]
  comment: string
  reasonResponse: any[]
  coordinates?: {lat: number; lng: number}
}

interface SectionOption {
  option: string
  from: number
  to: number
}

const TimeIntervals = ({interval = 15, index, questions, setQuestions, isReason = false}) => {
  return (
    <div>
      <DatePicker
        selected={
          isReason
            ? questions[index]?.reasonResponse?.[0]
              ? new Date(questions[index].reasonResponse[0])
              : new Date()
            : questions[index]?.response?.[0]
            ? new Date(questions[index].response[0])
            : new Date()
        }
        onChange={(date) => {
          setQuestions((prev) => {
            const updatedFormData = [...prev]
            if (isReason) {
              updatedFormData[index] = {
                ...updatedFormData[index],
                reasonResponse: [date],
              }
            } else {
              updatedFormData[index] = {
                ...updatedFormData[index],
                response: [date],
              }
            }
            return updatedFormData
          })
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={interval}
        dateFormat='h:mm aa'
        className='form-control'
      />
    </div>
  )
}

const InterviewQuestionaire: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const dispatch = useDispatch()
  const [validateInput, setValidateInput] = useState(false)
  const [data, setData] = useState([])
  const [interviewName, setInterviewName] = useState('')
  const [projectName, setProjectName] = useState('')
  const [questions, setQuestions] = useState<any>([
    {
      title: '',
      titleId: '',
      questionId: '',
      question: '',
      type: '',
      response: [],
      comment: '',
      reasonType: '',
      reasonTitle: '',
      reasonId: '',
      reasonResponse: [],
    },
  ])
  const {countries, loading: countryLoading} = useSelector((state: RootState) => state.country)
  const [locationName, setLocationName] = useState([])
  const [reasonLocationName, setReasonLocationName] = useState([])
  const [bool, setBool] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [coordinates, setCoordinates] = useState<{lat: number; lng: number} | null>(null)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [startedAt] = useState(new Date())
  const [submitting, setSubmitting] = useState(false)
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const [checkpoints, setCheckpoints] = useState<
    {index: number; sectionOptions: SectionOption[]}[]
  >([])

  // Auto-collapse sidebar on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setSidebarCollapsed(true)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const [skippedQuestionsIndex, setSkippedQuestionsIndex] = useState<number[]>([]) // Stores question order (1-based)

  // Re-used states for question numbering and orders
  const [questionNumberList, setQuestionNumberList] = useState<number[]>([]) // 1-based question number
  // const [tempOrdersList, setTempOrdersList] = useState<number[]>([]) // Question orders from API

  const [center, setCenter] = useState({
    lat: 25.276987,
    lng: 55.296249,
  })

  // set the center to the users current location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      if (position) {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      }
    })

    let startY = 0
    let maybePull = false

    const onTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].clientY
      // Only consider pull if at top
      const atTop = (document.scrollingElement?.scrollTop ?? window.pageYOffset) <= 0
      maybePull = atTop
    }

    const onTouchMove = (e: TouchEvent) => {
      if (!maybePull) return
      const dy = e.touches[0].clientY - startY
      if (dy > 0) {
        // Downward from top -> block refresh, but only for this condition
        e.preventDefault()
      } else {
        // Upward or no longer pulling -> stop gating
        maybePull = false
      }
    }

    document.addEventListener('touchstart', onTouchStart, {passive: true})
    document.addEventListener('touchmove', onTouchMove, {passive: false})

    return () => {
      document.removeEventListener('touchstart', onTouchStart)
      document.removeEventListener('touchmove', onTouchMove as any)
    }
  }, [])

  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  }

  const closeModal = () => {
    setCoordinates(null)
    setShowModal(false)
  }

  const saveLocation = () => {
    if (coordinates) {
      setQuestions((prev) => {
        const currentIndex = bool.findIndex((b) => b === true)
        if (currentIndex !== -1) {
          const updatedFormData = [...prev]
          updatedFormData[currentIndex] = {
            ...updatedFormData[currentIndex],
            coordinates: coordinates,
          }
          return updatedFormData
        }
        return prev
      })
    }
    setShowModal(false)
  }

  const handleMapClick = (event: any) => {
    setCoordinates({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    })
    setLocationName((prev) => {
      const updatedLocationName = [...prev]
      updatedLocationName[selectedIndex] = ''
      return updatedLocationName
    })
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      updatedFormData[selectedIndex] = {
        ...updatedFormData[selectedIndex],
        coordinates: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        },
      }
      return updatedFormData
    })
    setBool(Array(questions.length).fill(false))
  }

  // Function to calculate question numbers and skipped indices
  const calculateQuestionDisplayInfo = (
    allQuestions: QuestionData[],
    allCheckpoints: typeof checkpoints,
    currentQuestionResponses: InterviewQuestion[]
  ): {questionNumberList: number[]; skippedQuestionsIndex: number[]} => {
    let currentSkippedOrders: number[] = []

    // Collect all checkpoint orders to protect them from being skipped
    const checkpointOrders = allCheckpoints.map((cp) => cp.index + 1)

    // Step 1: Determine the unique set of question orders to be skipped
    allCheckpoints.forEach((cp) => {
      const checkpointQuestionIndex = allQuestions.findIndex(
        (q) => q.order === cp.index + 1 && q.type === 'checkpoint'
      )

      if (checkpointQuestionIndex !== -1) {
        const checkpointResponseValue =
          currentQuestionResponses[checkpointQuestionIndex]?.response?.[0]
        const allOrdersAfterCheckpoint = allQuestions
          .filter((q) => q.order - 1 > cp.index)
          .map((q) => q.order)

        let ordersToKeep: number[] = []
        const selectedOption = cp.sectionOptions.find(
          (opt) => opt.option === checkpointResponseValue
        )

        if (selectedOption) {
          for (let order = selectedOption.from; order <= selectedOption.to; order++) {
            ordersToKeep.push(order)
          }
        }

        // Skip any question order *after* the checkpoint that is NOT in the "keep range"
        // BUT exclude checkpoint questions themselves unless they're explicitly in another checkpoint's range
        const ordersToSkipFromThisCheckpoint = allOrdersAfterCheckpoint.filter((order) => {
          const isCheckpointQuestion = checkpointOrders.includes(order)
          if (isCheckpointQuestion) {
            return false
          }

          const isInKeepRange = ordersToKeep.includes(order)

          // For non-checkpoint questions, skip if not in keep range
          return !isInKeepRange
        })

        // if currentskippedorders contains orderstokeep, remove it
        ordersToKeep.forEach((order) => {
          if (currentSkippedOrders.includes(order)) {
            // remove all appearance of order from currentSkippedOrders
            currentSkippedOrders = currentSkippedOrders.filter((o) => o !== order)
          }
        })

        currentSkippedOrders.push(...ordersToSkipFromThisCheckpoint)
      }
    })

    const finalSkippedOrders = Array.from(new Set(currentSkippedOrders))
    // setTempOrdersList(allQuestions.map((q) => q.order)) // Re-sync the base orders if needed

    // Step 2: Group questions (same logic as in the render block) to establish sequential numbering
    const titleGroups: any = {}
    const standaloneQuestions: any[] = []
    allQuestions.forEach((element, index) => {
      if (element.title && element.title.trim() !== '') {
        const groupKey = `${element.title}-${element.order}`
        if (!titleGroups[groupKey]) {
          titleGroups[groupKey] = {
            title: element.title,
            order: element.order,
            questions: [],
            indices: [],
          }
        }
        titleGroups[groupKey].questions.push({...element, originalIndex: index})
        titleGroups[groupKey].indices.push(index)
      } else {
        standaloneQuestions.push({...element, originalIndex: index})
      }
    })
    standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    const sortedGroups = Object.values(titleGroups).sort(
      (a: any, b: any) => (a.order || 0) - (b.order || 0)
    )

    const combinedItems = [
      ...standaloneQuestions.map((q) => ({
        type: 'standalone',
        question: q,
        order: q.order || 0,
        originalOrder: q.order,
      })),
      ...sortedGroups.map((g: any) => ({type: 'group', ...g, originalOrder: g.order})),
    ]
    combinedItems.sort((a, b) => a.order - b.order)

    // Step 3: Map the Final Display Number (0 if skipped, > 0 if visible)
    const numberedListForFlatArray = Array(allQuestions.length).fill(0) // Initialize all to 0 (skipped)
    let finalQuestionNumber = 1

    combinedItems.forEach((item) => {
      const itemOrder = item.originalOrder

      // Checkpoints themselves are special: they must always appear if they are before the *first* skip is applied
      const isCheckpoint = item.type === 'standalone' && item.question.type === 'checkpoint'

      // An item is VISIBLE if its order is NOT in the skipped list OR it is a checkpoint itself
      const isVisible = !finalSkippedOrders.includes(itemOrder) || isCheckpoint

      if (isVisible) {
        const indicesToNumber: number[] =
          item.type === 'standalone'
            ? [item.question.originalIndex]
            : item.questions.map((q) => q.originalIndex)

        // Assign the sequential display number to ALL associated original indices
        indicesToNumber.forEach((originalIndex) => {
          // Only assign the number if the individual question isn't explicitly configured as skipped
          // (e.g., if a group is visible, but one sub-question's order was in the skip range).
          // With our logic, checking the item's order is sufficient:
          numberedListForFlatArray[originalIndex] = finalQuestionNumber
        })
        finalQuestionNumber++
      }
    })

    return {
      questionNumberList: numberedListForFlatArray,
      skippedQuestionsIndex: finalSkippedOrders,
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const res = await getInterviewbyid(params.id)
      setInterviewName(res.interviewName)
      setProjectName(res.project.name)
      const fetchedData: QuestionData[] = res.questions
      setData(fetchedData)
      const initialQuestions: InterviewQuestion[] = fetchedData.map((item, index) => {
        const baseQuestion: InterviewQuestion = {
          title: item.title,
          titleId: item?.titleId || '',
          questionId: item?.questionId || '',
          question: item.question,
          type: item.type,
          response: item.type === 'text' ? item.options : [], // This seems odd from original, but maintaining
          comment: '',
          reasonType: item.reasonType,
          reasonTitle: item.reasonTitle,
          reasonId: item.reasonId || '',
          reasonResponse: [],
          order: item.order,
          required: item.required,
          other: item.other,
          reason: item.reason,
          checkpointId: item.checkpointId,
        }

        if (item.type === 'location') {
          // @ts-ignore
          baseQuestion.coordinates = item.coordinates
        }
        return baseQuestion
      })

      const sortedCheckpoints = res.checkpoints?.sort((a, b) => a.index - b.index) || []

      setQuestions(initialQuestions)
      setCheckpoints(sortedCheckpoints)
      setBool(Array(fetchedData.length).fill(false))
      setLocationName(Array(fetchedData.length).fill(''))
      setReasonLocationName(Array(fetchedData.length).fill(''))

      // const orders = fetchedData.map((item) => item.order)
      // setTempOrdersList(orders)

      // Initial calculation of skipped questions and numbering
      const {questionNumberList: initialNumberList, skippedQuestionsIndex: initialSkipped} =
        calculateQuestionDisplayInfo(fetchedData, sortedCheckpoints, initialQuestions)

      setQuestionNumberList(initialNumberList)
      setSkippedQuestionsIndex(initialSkipped)
    }

    fetchData()

    const fetchCountries = async () => {
      const data = await getCountries()
      const temp = data.map((country: {name: {common: string}}) => ({
        label: country?.name?.common,
        value: country?.name?.common,
      }))
      dispatch(setCountries(temp))
    }

    if (countryLoading) {
      fetchCountries()
    }
  }, [])

  const handleFormSubmit = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setSubmitting(true)

    // Filter questions based on current skipped status for validation
    const visibleQuestions = questions.filter((_, idx) => {
      const element = data[idx]
      // Check if the current question's order is in the skipped list
      const isSkipped = skippedQuestionsIndex.includes(element.order)
      // Display if it's a checkpoint OR it's not skipped.
      return element.type === 'checkpoint' || !isSkipped
    })

    const isFormValid = visibleQuestions.every((item, idx) => {
      const originalIndex = data.findIndex(
        (q) => q.order === item.order && q.question === item.question
      ) // Find original index for data mapping
      const elem = data[originalIndex]

      if (!elem.required) return true // Skip validation if not required

      const response = item.response?.[0]
      switch (item.type) {
        case 'text':
        case 'preference':
          return typeof response === 'string' && response.trim().length >= 3
        case 'number':
          return !isNaN(Number(response))
        case 'date':
        case 'time':
        case 'time-15':
        case 'time-30':
        case 'time-60':
        case 'country':
          return Boolean(response)
        case 'location':
          // Check for both text response and coordinates
          return (
            item.response.length > 0 &&
            item.coordinates &&
            item.coordinates.lat &&
            item.coordinates.lng
          )
        default: // Checkbox, Multiple, Dropdown, Rank, Checkpoint
          return item.response.length > 0
      }
    })

    if (!isFormValid) {
      setValidateInput(true)
      setSubmitting(false)
      await Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#007bff',
      })
      return
    }

    const getCurrentLocation = () =>
      new Promise<{lat: number; lng: number}>((resolve, reject) => {
        if (!('geolocation' in navigator)) return reject('Geolocation not supported')
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({lat: pos.coords.latitude, lng: pos.coords.longitude}),
          (err) => reject(err)
        )
      })

    try {
      const {lat, lng} = await getCurrentLocation()

      // ✅ Build payload efficiently
      const filteredQuestions = questions
        .map((item, idx) => {
          const element = data[idx]
          // If the question is in the skipped list AND is not a checkpoint, return null
          if (element.type !== 'checkpoint' && skippedQuestionsIndex.includes(element.order)) {
            return null
          }
          // Otherwise, include the question (for checkpoint responses or displayed questions)
          return item.type === 'checkbox'
            ? {...item, response: item.response, question: removeAsterisk(item.question)}
            : {...item, question: removeAsterisk(item.question)}
        })
        .filter(Boolean)

      const payload = {
        interviewId: params.id,
        questions: filteredQuestions,
        lat,
        lng,
        createdBy: currentUser?._id,
        startedAt,
      }

      const res = await postResponse(payload)

      if (res) {
        await Swal.fire({
          title: 'Success',
          text: 'Response submitted successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#007bff',
        })
        navigate('/interview')
      }
    } catch (error) {
      console.error('Error submitting response', error)
    } finally {
      setSubmitting(false)
    }
  }

  const handleSelect = async (address: string, index: number) => {
    try {
      const results = await geocodeByAddress(address)
      const latLng = await getLatLng(results[0])
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          response: [address],
          coordinates: {lat: latLng.lat, lng: latLng.lng},
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleReasonSelect = async (address: string, index: number) => {
    try {
      setQuestions((prev) => {
        const updatedFormData = [...prev]
        updatedFormData[index] = {
          ...updatedFormData[index],
          reasonResponse: [address],
        }
        return updatedFormData
      })
    } catch (error) {
      console.error('Error selecting location', error)
    }
  }

  const handleInputChange = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      const parsedValue = parseFloat(value)
      updatedFormData[index] = {
        ...updatedFormData[index],
        response: type === 'text' ? [value] : isNaN(parsedValue) ? [] : [parsedValue],
      }
      return updatedFormData
    })
  }

  const handleInputChangeReason = (index: number, value: any, type: string) => {
    setQuestions((prev) => {
      const updatedFormData = [...prev]
      const parsedValue = parseFloat(value)
      updatedFormData[index] = {
        ...updatedFormData[index],
        reasonResponse: type === 'text' ? [value] : isNaN(parsedValue) ? [] : [parsedValue],
      }
      return updatedFormData
    })
  }

  function handleCheckpointValueChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number
  ) {
    const selectedOptionValue = e.target.value

    // 1. Calculate the hypothetical new state for 'questions'
    const newQuestionsState = questions.map((q, i) =>
      i === index ? {...q, response: [selectedOptionValue]} : q
    )

    // 2. Calculate new skipped and numbering based on this hypothetical state
    // We pass the new state to the calculation utility
    const {questionNumberList: newNumberList, skippedQuestionsIndex: newSkippedIndices} =
      calculateQuestionDisplayInfo(data, checkpoints, newQuestionsState)

    // 3. Update the display states first (synchronously)
    setSkippedQuestionsIndex(newSkippedIndices)
    setQuestionNumberList(newNumberList)

    // 4. Update the main questions state (asynchronously, but already reflected in display logic)
    setQuestions(newQuestionsState)
  }

  const scrollToQuestion = (questionIndex: number) => {
    const element = document.getElementById(`question-${questionIndex}`)
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'start'})
      setActiveQuestionIndex(questionIndex)
    }
  }

  const getAnsweredQuestionsCount = () => {
    const visibleQuestions = questions.filter((_, idx) => {
      const element = data[idx]
      const isSkipped = skippedQuestionsIndex.includes(element?.order)
      return element?.type === 'checkpoint' || !isSkipped
    })
    return visibleQuestions.filter(
      (q) => q.response && q.response.length > 0 && String(q.response?.[0]).length > 1
    ).length
  }

  const getTotalVisibleQuestions = () => {
    return questions.filter((_, idx) => {
      const element = data[idx]
      const isSkipped = skippedQuestionsIndex.includes(element?.order)
      return element?.type === 'checkpoint' || !isSkipped
    }).length
  }

  const ProgressDonut = ({answered, total}: {answered: number; total: number}) => {
    const percentage = total > 0 ? Math.round((answered / total) * 100) : 0
    const radius = 45
    const circumference = 2 * Math.PI * radius
    const offset = circumference - (percentage / 100) * circumference
    const borderRadius = radius + 6

    return (
      <div className='relative flex flex-col items-center mb-6'>
        <svg width='120' height='120' className='transform -rotate-90'>
          {/* Background circle with subtle shadow */}
          <defs>
            <filter id='shadow'>
              <feDropShadow dx='0' dy='2' stdDeviation='3' floodOpacity='0.1' />
            </filter>
            <linearGradient id='progressGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
              <stop offset='0%' stopColor='#3b82f6' />
              <stop offset='100%' stopColor='#60a5fa' />
            </linearGradient>
          </defs>

          <circle
            cx='60'
            cy='60'
            r={borderRadius}
            stroke='#e5e7eb' // gray-200
            strokeWidth='2'
            fill='none'
          />

          {/* Background track */}
          <circle cx='60' cy='60' r={radius} stroke='#f3f4f6' strokeWidth='10' fill='none' />

          {/* Progress circle with gradient */}
          <circle
            cx='60'
            cy='60'
            r={radius}
            stroke='url(#progressGradient)'
            strokeWidth='10'
            fill='none'
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap='round'
            filter='url(#shadow)'
            style={{
              transition: 'stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          />
        </svg>

        {/* Center text with smooth transitions */}
        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center'>
          <div
            className='text-3xl font-bold bg-gradient-to-br from-blue-600 to-blue-500 bg-clip-text text-transparent transition-all duration-300 border'
            key={percentage}
          >
            {percentage}%
          </div>
          <div className='text-xs font-medium text-gray-500 mt-1 transition-all duration-300'>
            {answered} of {total}
          </div>
        </div>

        {/* Subtle glow effect */}
        <div className='absolute inset-0 rounded-full bg-blue-500/5 blur-xl -z-10' />
      </div>
    )
  }

  return (
    <section className='min-h-screen bg-gray-50'>
      <div className='flex h-screen overflow-hidden relative'>
        {/* Mobile Sidebar Toggle Button */}
        <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className='lg:hidden fixed top-4 left-4 z-50 bg-white shadow-lg p-3 rounded-lg border border-gray-200'
        >
          <svg
            className='w-6 h-6 text-gray-700'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            {sidebarCollapsed ? (
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M4 6h16M4 12h16M4 18h16'
              />
            ) : (
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M6 18L18 6M6 6l12 12'
              />
            )}
          </svg>
        </button>

        {/* Sidebar Overlay for Mobile */}
        {!sidebarCollapsed && (
          <div
            className='lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30'
            onClick={() => setSidebarCollapsed(true)}
          />
        )}

        {/* Sidebar */}
        <div
          className={`${
            sidebarCollapsed ? '-translate-x-full lg:translate-x-0 lg:w-0' : 'translate-x-0 lg:w-80'
          } fixed lg:relative z-40 w-80 bg-light transition-all duration-300 overflow-hidden flex flex-col h-screen`}
        >
          <div className='p-4 lg:p-6 border-b'>
            <ProgressDonut
              answered={getAnsweredQuestionsCount()}
              total={getTotalVisibleQuestions()}
            />
          </div>
          <div className='flex-1 overflow-y-auto p-3 lg:p-4'>
            <h4 className='text-xs lg:text-sm font-semibold text-gray-500 uppercase mb-3'>
              Questions
            </h4>
            <div className='space-y-2'>
              {(() => {
                const visibleItems: any[] = []
                const titleGroups: any = {}
                const standaloneQuestions: any[] = []

                data.forEach((element, index) => {
                  if (element.title && element.title.trim() !== '') {
                    const groupKey = `${element.title}-${element.order}`
                    if (!titleGroups[groupKey]) {
                      titleGroups[groupKey] = {
                        title: element.title,
                        order: element.order,
                        questions: [],
                        indices: [],
                      }
                    }
                    titleGroups[groupKey].questions.push({...element, originalIndex: index})
                    titleGroups[groupKey].indices.push(index)
                  } else {
                    standaloneQuestions.push({...element, originalIndex: index})
                  }
                })

                standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
                const sortedGroups = Object.values(titleGroups).sort(
                  (a: any, b: any) => (a.order || 0) - (b.order || 0)
                )

                const allItems = [
                  ...standaloneQuestions.map((q) => ({
                    type: 'standalone',
                    question: q,
                    order: q.order || 0,
                  })),
                  ...sortedGroups.map((g: any) => ({type: 'group', ...g})),
                ]
                allItems.sort((a, b) => (a.order || 0) - (b.order || 0))

                allItems.forEach((item, idx) => {
                  const itemOrder = item.type === 'standalone' ? item.question.order : item.order
                  const isSkipped = skippedQuestionsIndex.includes(itemOrder)
                  if (!isSkipped) {
                    let displayQuestionNumber = 0
                    if (item.type === 'standalone') {
                      displayQuestionNumber = questionNumberList[item.question.originalIndex]
                    } else {
                      const firstQuestionIndex = item.questions[0]?.originalIndex
                      if (firstQuestionIndex !== undefined) {
                        displayQuestionNumber = questionNumberList[firstQuestionIndex]
                      }
                    }
                    if (displayQuestionNumber !== 0) {
                      visibleItems.push({
                        ...item,
                        displayNumber: displayQuestionNumber,
                        visualIndex: visibleItems.length,
                      })
                    }
                  }
                })

                return visibleItems.map((item) => {
                  const isAnswered =
                    item.type === 'standalone'
                      ? questions[item.question.originalIndex]?.response?.length > 0 &&
                        String(questions[item.question.originalIndex]?.response?.[0])?.length > 0
                      : item.questions.some((q) => questions[q.originalIndex]?.response?.length > 0)

                  return (
                    <button
                      key={`sidebar-${item.visualIndex}`}
                      onClick={() => scrollToQuestion(item.visualIndex)}
                      className={`w-full text-left p-2 lg:p-3 rounded-lg transition-all relative ${
                        activeQuestionIndex === item.visualIndex || isAnswered
                          ? 'bg-light-info border border-info'
                          : 'border border-gray-300'
                      }`}
                    >
                      <div className='flex items-center gap-3'>
                        {isAnswered ? (
                          <div className='w-6 h-6 bg-info rounded-full flex items-center justify-center flex-shrink-0'>
                            <svg
                              className='w-4 h-4 text-white'
                              fill='none'
                              stroke='currentColor'
                              viewBox='0 0 24 24'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M5 13l4 4L19 7'
                              />
                            </svg>
                          </div>
                        ) : (
                          <div
                            className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 ${
                              activeQuestionIndex === item.visualIndex
                                ? 'bg-info text-white'
                                : 'bg-secondary text-dark'
                            }`}
                          >
                            <span className='text-xs'>{item.displayNumber}</span>
                          </div>
                        )}
                        <div className='flex-1 min-w-0'>
                          <p className='text-xs lg:text-sm text-gray-700 line-clamp-2 mb-0'>
                            {item.type === 'standalone'
                              ? removeAsterisk(item.question.question)
                              : item.title}
                          </p>
                        </div>
                      </div>
                    </button>
                  )
                })
              })()}
            </div>
          </div>
        </div>

        {/* Toggle Sidebar Button */}
        {/* <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className='fixed left-0 top-1/2 transform -translate-y-1/2 bg-blue-600 text-white p-2 rounded-r-lg shadow-lg z-50 hover:bg-blue-700 transition-colors'
          style={{left: sidebarCollapsed ? '0' : '20rem'}}
        >
          <KTIcon iconName={sidebarCollapsed ? 'right' : 'left'} className='fs-3' />
        </button> */}

        {/* Main Content */}
        <div className='flex-1 overflow-y-auto bg-light'>
          <div className='max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:pb-8 pb-20'>
            <div className='p-4 sm:p-6 lg:p-8 bg-light'>
              <div className='card mb-10'>
                <div className='card-header'>
                  <div className='card-title d-flex flex-column pt-4'>
                    <h3 className='text-lg lg:text-xl font-bold text-gray-800 mb-2'>
                      {interviewName}
                    </h3>
                    <p className='text-xs lg:text-sm text-gray-600 mb-4'>{projectName}</p>
                  </div>
                </div>
              </div>

              <form id='kt_modal_add_user_form' className='form'>
                <div className='flex flex-col justify-around gap-8 text-gray-800'>
                  {(() => {
                    // Group questions by title and order, then add numbering
                    const titleGroups: any = {}
                    const standaloneQuestions = []

                    // First pass: group by title and collect standalone questions
                    data.forEach((element, index) => {
                      if (element.title && element.title.trim() !== '') {
                        // Has a title - group it
                        const groupKey = `${element.title}-${element.order}`
                        if (!titleGroups[groupKey]) {
                          titleGroups[groupKey] = {
                            title: element.title,
                            order: element.order,
                            questions: [],
                            indices: [],
                          }
                        }
                        titleGroups[groupKey].questions.push({
                          ...element,
                          originalIndex: index,
                        })
                        titleGroups[groupKey].indices.push(index)
                      } else {
                        // No title - standalone question
                        standaloneQuestions.push({
                          ...element,
                          originalIndex: index,
                        })
                      }
                    })

                    // Sort standalone questions by order
                    standaloneQuestions.sort((a: any, b: any) => (a.order || 0) - (b.order || 0))

                    // Sort groups by order
                    const sortedGroups = Object.values(titleGroups).sort(
                      (a: any, b: any) => (a.order || 0) - (b.order || 0)
                    )

                    // Sort questions within each group by their original order in the array
                    sortedGroups.forEach((group: any) => {
                      group.questions.sort((a: any, b: any) => a.originalIndex - b.originalIndex)
                    })

                    // Combine standalone questions and groups, maintaining order
                    const allItems = [
                      ...standaloneQuestions.map((q) => ({
                        type: 'standalone',
                        question: q,
                        order: q.order || 0,
                      })),
                      ...sortedGroups.map((g: any) => ({type: 'group', ...g})),
                    ]

                    // Sort by order
                    allItems.sort((a, b) => (a.order || 0) - (b.order || 0))

                    // Add question numbering after sorting
                    return allItems.map((item, groupIndex) => {
                      // Determine the question order for visibility check
                      const itemOrder =
                        item.type === 'standalone' ? item.question.order : item.order

                      // Check if this item is marked to be skipped
                      // For a group, check the order of the group itself.
                      const isSkipped = skippedQuestionsIndex.includes(itemOrder)

                      // The original logic checked against `checkpointIndex + 1`.
                      // With multiple checkpoints, this check should only happen if this item is AFTER *all* checkpoint questions that might affect it.
                      // Simpler rule: if `itemOrder` is in the `skippedQuestionsIndex` array, do not render.
                      if (isSkipped) {
                        return null
                      }

                      // Get the display question number from the state list (which was pre-calculated)
                      let displayQuestionNumber = 0
                      if (item.type === 'standalone') {
                        displayQuestionNumber = questionNumberList[item.question.originalIndex]
                      } else {
                        // For groups, find the original index of the first question in the group to get the number
                        const firstQuestionIndex = item.questions[0]?.originalIndex
                        if (firstQuestionIndex !== undefined) {
                          displayQuestionNumber = questionNumberList[firstQuestionIndex]
                        }
                      }

                      // Don't render if the display number is 0 (meaning it was filtered out by the calculation logic)
                      if (displayQuestionNumber === 0) {
                        return null
                      }

                      if (item.type === 'standalone') {
                        const element = item.question
                        const index = element.originalIndex

                        return (
                          <div
                            key={`standalone-${groupIndex}`}
                            id={`question-${displayQuestionNumber - 1}`}
                            className='question-container bg-light border border-gray-200 p-4 sm:p-6 rounded-xl mb-4 sm:mb-6 shadow-sm hover:shadow-md transition-shadow'
                          >
                            <div className='mb-2'>
                              <span className='text-xs font-semibold badge badge-light-info text-info uppercase tracking-wide break-words'>
                                Question {displayQuestionNumber}
                              </span>
                            </div>
                            <div>
                              <p className='text-base sm:text-lg mb-4 text-gray-900 font-medium leading-relaxed'>
                                <span
                                  dangerouslySetInnerHTML={{__html: parseBold(element.question)}}
                                />{' '}
                                {element.required && (
                                  <span className='text-red-600 text-xl'>*</span>
                                )}
                              </p>
                              {element.type === 'checkpoint'
                                ? renderCheckpointQuestionInput(element, index)
                                : renderQuestionInput(element, index)}
                            </div>
                          </div>
                        )
                      } else {
                        // Group type

                        // Filter questions within the group based on being skipped
                        const visibleSubQuestions = item.questions.filter((q) => {
                          // For a rank group, render all if the group container is rendered.
                          if (q.type === 'rank') return true
                          // For non-rank questions within a group, they are all assumed to be visible if the group is visible.
                          return true
                        })

                        if (visibleSubQuestions.length === 0) return null

                        return (
                          <div
                            key={`group-${groupIndex}`}
                            id={`question-${displayQuestionNumber - 1}`}
                            className='question-group-container bg-light border border-gray-200 rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow mb-4 sm:mb-6'
                          >
                            <div className='mb-2'>
                              <span className='text-xs font-semibold badge badge-light-info text-info uppercase tracking-wide break-words'>
                                Question {displayQuestionNumber}
                              </span>
                            </div>
                            <h2 className='text-base sm:text-lg font-medium mb-4 sm:mb-6 text-gray-900 pb-3 border-b border-gray-200'>
                              {item.title}
                            </h2>
                            <div className='space-y-4'>
                              {item.questions.map((element, subIndex) => {
                                const isRank = element.type === 'rank'
                                const index = element.originalIndex

                                // For rank group, only render the header once
                                if (isRank) {
                                  if (subIndex === 0) {
                                    // renderRankQuestions is an existing helper function
                                    return renderRankQuestions(
                                      item.questions,
                                      displayQuestionNumber
                                    )
                                  }
                                  return (
                                    <React.Fragment
                                      key={`sub-rank-spacer-${subIndex}`}
                                    ></React.Fragment>
                                  )
                                }

                                // Check if an individual question within the group is skipped (shouldn't happen with group-skipping, but defensive)
                                const isIndividualSkipped = skippedQuestionsIndex.includes(
                                  element.order
                                )
                                if (isIndividualSkipped) return null

                                return (
                                  <div
                                    key={`sub-${subIndex}`}
                                    className='sub-question border-l-4 border-blue-500 pl-3 sm:pl-6 py-3 mb-3'
                                  >
                                    <div>
                                      <p className='text-base mb-3 text-gray-800 font-medium leading-relaxed'>
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: parseBold(element.question),
                                          }}
                                        />{' '}
                                        {element.required && (
                                          <span className='text-red-600 text-lg'>*</span>
                                        )}
                                      </p>
                                      {renderQuestionInput(element, index)}
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      }
                    })

                    // Helper function to render question inputs (extracted to avoid repetition)
                    function renderQuestionInput(element, index) {
                      return (
                        <>
                          {element.type === 'text' && (
                            <div>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0 text-base p-3'
                                placeholder={removeAsterisk(element.question)}
                                required={element.required}
                                value={questions[index].response[0] ?? ''}
                                onChange={(e) => handleInputChange(index, e.target.value, 'text')}
                              />
                              {element.required &&
                                validateInput &&
                                (questions[index].response?.[0] === undefined ||
                                  questions[index].response[0]?.length < 3) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input cannot be less than 3!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.type === 'number' && (
                            <div className='mb-3'>
                              <input
                                type='number'
                                className='form-control form-control-solid mb-3 mb-lg-0 text-base p-3'
                                placeholder={removeAsterisk(element.question)}
                                required={element.required}
                                value={questions[index].response[0] ?? ''}
                                onChange={(e) => handleInputChange(index, e.target.value, 'number')}
                              />
                              {element.required &&
                                validateInput &&
                                (questions[index].response[0] === '' ||
                                  isNaN(questions[index].response[0])) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input must be a valid number!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.type === 'checkbox' && (
                            <div className='flex flex-col gap-2'>
                              <div className='flex flex-col gap-2'>
                                {element.options.map((currElem, idx) => (
                                  <label
                                    key={idx}
                                    className={`form-check-label text-sm sm:text-base cursor-pointer p-2 sm:p-3 rounded-lg border transition-all ${
                                      questions[index].response.includes(currElem)
                                        ? 'bg-light-primary border-primary shadow-md'
                                        : 'border-secondary border-hover-primary'
                                    }`}
                                  >
                                    <input
                                      type='checkbox'
                                      className='form-check-input me-3'
                                      value={currElem}
                                      checked={questions[index].response.includes(currElem)}
                                      onChange={(e) =>
                                        setQuestions((prev) => {
                                          const updatedFormData = [...prev]
                                          if (e.target.checked) {
                                            updatedFormData[index] = {
                                              ...updatedFormData[index],
                                              response: [
                                                ...updatedFormData[index].response,
                                                e.target.value,
                                              ],
                                            }
                                          } else {
                                            updatedFormData[index] = {
                                              ...updatedFormData[index],
                                              response: updatedFormData[index].response.filter(
                                                (item) => item !== e.target.value
                                              ),
                                            }
                                          }
                                          return updatedFormData
                                        })
                                      }
                                    />
                                    {currElem}
                                  </label>
                                ))}
                              </div>
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    This option is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'multiple' && (
                            <div className='flex flex-col gap-2'>
                              <div className='flex flex-col gap-2'>
                                {element.options.map((currElem, idx) => (
                                  <label
                                    key={idx}
                                    className={`form-check-label text-sm sm:text-base cursor-pointer p-2 sm:p-3 rounded-lg border transition-all ${
                                      questions[index].response[0] === currElem
                                        ? 'bg-light-primary border-primary shadow-md'
                                        : 'border-secondary border-hover-primary'
                                    }`}
                                  >
                                    <input
                                      type='radio'
                                      name={`radio${index}`}
                                      className='form-check-input me-3'
                                      required={element.required}
                                      value={currElem}
                                      onChange={(e) =>
                                        setQuestions((prev) => {
                                          const updatedFormData = [...prev]
                                          updatedFormData[index] = {
                                            ...updatedFormData[index],
                                            response: [e.target.value],
                                          }
                                          return updatedFormData
                                        })
                                      }
                                    />
                                    {currElem}
                                  </label>
                                ))}
                                {element.required &&
                                  validateInput &&
                                  questions[index].response.length < 1 && (
                                    <div className='alert alert-danger mt-2' role='alert'>
                                      This option is required
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}

                          {element.type === 'preference' && (
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                              {element.preferenceOptions?.map((option, optIdx) => {
                                const responseString = `${option.title}, AED ${option.totalCost}, ${option.totalTime}`
                                const isSelected = questions[index].response[0] === responseString

                                return (
                                  <div
                                    key={optIdx}
                                    className={`d-flex flex-column justify-content-between border rounded-lg p-4 cursor-pointer transition-all ${
                                      isSelected
                                        ? 'bg-light-primary border-primary shadow-md'
                                        : 'border-secondary hover:border-primary'
                                    }`}
                                    onClick={() =>
                                      setQuestions((prev) => {
                                        const updatedFormData = [...prev]
                                        updatedFormData[index] = {
                                          ...updatedFormData[index],
                                          response: [responseString],
                                        }
                                        return updatedFormData
                                      })
                                    }
                                  >
                                    <div className='flex items-center gap-3 mb-3'>
                                      <img
                                        src={toAbsoluteUrl(
                                          `/media/svg/preference/${option.icon || 'car'}.svg`
                                        )}
                                        alt={option.title}
                                        className='w-50 h-50'
                                      />
                                      <h4 className='mb-0 font-semibold text-lg'>{option.title}</h4>
                                    </div>

                                    <div className='space-y-2 mb-3'>
                                      {option.fuel > 0 && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <BsFuelPumpFill className='fs-6' />
                                          <span>Fuel</span>
                                          <span className='ml-auto font-medium'>
                                            {option.fuel} AED
                                          </span>
                                        </div>
                                      )}
                                      {option.fare > 0 && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <KTIcon iconName='price-tag' className='fs-6' />
                                          <span>Fare</span>
                                          <span className='ml-auto font-medium'>
                                            {option.fare} AED
                                          </span>
                                        </div>
                                      )}
                                      {option.tolls > 0 && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <KTIcon iconName='purchase' className='fs-6' />
                                          <span>Tolls</span>
                                          <span className='ml-auto font-medium'>
                                            {option.tolls} AED
                                          </span>
                                        </div>
                                      )}
                                      {option.parking > 0 && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <TbParkingCircleFilled className='fs-6' />
                                          <span>Parking</span>
                                          <span className='ml-auto font-medium'>
                                            {option.parking} AED
                                          </span>
                                        </div>
                                      )}
                                      {option.toFrom && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <KTIcon iconName='route' className='fs-6' />
                                          <span>To/from stations</span>
                                          <span className='ml-auto font-medium'>
                                            {option.toFrom}
                                          </span>
                                        </div>
                                      )}
                                      {option.timeToTravel && (
                                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                                          <KTIcon iconName='time' className='fs-6' />
                                          <span>Time on train</span>
                                          <span className='ml-auto font-medium'>
                                            {option.timeToTravel}
                                          </span>
                                        </div>
                                      )}
                                    </div>

                                    <div className='flex gap-2 mt-4'>
                                      <div className='flex-1 border border-gray-300 rounded p-2 text-center'>
                                        <div className='text-xs text-gray-500 mb-1'>Total Cost</div>
                                        <div className='font-semibold'>{option.totalCost} AED</div>
                                      </div>
                                      <div className='flex-1 border border-gray-300 rounded p-2 text-center'>
                                        <div className='text-xs text-gray-500 mb-1'>Total Time</div>
                                        <div className='font-semibold'>{option.totalTime}</div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div
                                    className='col-span-full alert alert-danger mt-2'
                                    role='alert'
                                  >
                                    Please select a preference
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'dropdown' && (
                            <div>
                              <select
                                className='form-select form-select-solid mb-2 text-base p-3'
                                data-control='select2'
                                data-placeholder='Latest'
                                data-hide-search='true'
                                required={element.required}
                                defaultValue=''
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      response: [e.target.value],
                                    }
                                    return updatedFormData
                                  })
                                }
                              >
                                <option value=''>Select</option>
                                {element.options.map((currElem, idx) => (
                                  <option key={idx} value={currElem}>
                                    {currElem}
                                  </option>
                                ))}
                              </select>
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    This option is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'date' && (
                            <div>
                              <Flatpickr
                                className='form-control form-control-solid my-3'
                                placeholder={removeAsterisk(element.question)}
                                required={element.required}
                                options={{
                                  dateFormat: 'd-m-Y',
                                }}
                                value={
                                  questions[index].response
                                    ? new Date(questions[index].response[0])
                                    : ''
                                }
                                onChange={(date) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      response: [new Date(date).toISOString()],
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Date is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'time' && (
                            <div>
                              <Flatpickr
                                className='form-control form-control-solid my-3'
                                placeholder={removeAsterisk(element.question)}
                                required={element.required}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: 'H:i',
                                  time_24hr: true,
                                }}
                                value={
                                  questions[index].response
                                    ? new Date(questions[index].response[0])
                                    : ''
                                }
                                onChange={(date) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      response: [new Date(date).toISOString()],
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'time-15' && (
                            <div>
                              <TimeIntervals
                                interval={15}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'time-30' && (
                            <div>
                              <TimeIntervals
                                interval={30}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'time-60' && (
                            <div>
                              <TimeIntervals
                                interval={60}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'country' && (
                            <div>
                              <Select
                                options={countries}
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      response: [e?.value || ''],
                                    }
                                    return updatedFormData
                                  })
                                }
                                isClearable
                                filterOption={(option, inputValue) =>
                                  option.label.toLowerCase().startsWith(inputValue.toLowerCase())
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Country is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.type === 'location' && (
                            <div>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder={removeAsterisk(element.question)}
                                required={element.required}
                                value={questions[index].response[0] ?? ''}
                                onChange={(e) => handleInputChange(index, e.target.value, 'text')}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].response[0]?.length < 3 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input cannot be less than 3!
                                  </div>
                                )}
                              <div className='d-flex gap-2 my-3'>
                                <PlacesAutocomplete
                                  value={locationName[index]}
                                  onChange={(value) =>
                                    setLocationName((prev) => {
                                      const updatedLocationName = [...prev]
                                      updatedLocationName[index] = value
                                      return updatedLocationName
                                    })
                                  }
                                  onSelect={(value) => handleSelect(value, index)}
                                  searchOptions={{
                                    location: new google.maps.LatLng(25.276987, 55.296249),
                                    radius: 300000,
                                    componentRestrictions: {country: 'ae'},
                                  }}
                                >
                                  {({
                                    getInputProps,
                                    suggestions,
                                    getSuggestionItemProps,
                                    loading,
                                  }) => (
                                    <div className='flex-grow-1'>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Search Location...',
                                          className:
                                            'location-search-input form-control form-control-solid',
                                        })}
                                      />
                                      <div className='autocomplete-dropdown-container'>
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion) => (
                                          <div
                                            {...getSuggestionItemProps(suggestion, {
                                              className: suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item',
                                            })}
                                            key={suggestion.placeId}
                                            className='cursor-pointer form-control form-control-solid'
                                          >
                                            <span>{suggestion.description}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                                <button
                                  type='button'
                                  className='btn btn-light-primary'
                                  onClick={() => {
                                    setBool((prev) => {
                                      const updatedBool = Array(prev.length).fill(false)
                                      updatedBool[index] = true
                                      return updatedBool
                                    })
                                    setSelectedIndex(index)
                                    setCoordinates(questions[index].coordinates)
                                    if (questions[index].coordinates) {
                                      setCenter({
                                        lat: questions[index].coordinates.lat,
                                        lng: questions[index].coordinates.lng,
                                      })
                                    }
                                    setShowModal(true)
                                  }}
                                  title='Choose Location'
                                >
                                  <KTIcon iconName='map' className='fs-2' />
                                </button>
                              </div>
                              {questions[index].coordinates && (
                                <div>
                                  <p>Latitude: {questions[index].coordinates.lat}</p>
                                  <p>Longitude: {questions[index].coordinates.lng}</p>
                                </div>
                              )}
                              {element.required &&
                                validateInput &&
                                (!questions[index].response ||
                                  questions[index].response.length === 0) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    At least one location is required!
                                  </div>
                                )}
                              {element.required &&
                                validateInput &&
                                (!questions[index].coordinates ||
                                  questions[index].coordinates.length === 0) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    At least one location is required!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.other && (
                            <div className='mb-2 mt-3'>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder='other (Please Specify)'
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      response: [e.target.value],
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                              {element.required &&
                                validateInput &&
                                (questions[index].response.length < 1 ||
                                  questions[index].response[0]?.length < 1) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input cannot be less than 3!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.comment && (
                            <div>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder='Comment'
                                value={questions[index].comment}
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      comment: e.target.value,
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                            </div>
                          )}
                          {element.reason && renderReasonQuestionInput(element, index)}
                        </>
                      )
                    }

                    function renderReasonQuestionInput(element, index) {
                      return (
                        <>
                          <div className='mt-1'>
                            <p>{element.reasonTitle || 'Reason'}</p>
                          </div>
                          {element.reasonType === 'text' && (
                            <div>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder={removeAsterisk(element.reasonTitle || 'Reason')}
                                required={element.required}
                                value={questions[index].reasonResponse[0] ?? ''}
                                onChange={(e) =>
                                  handleInputChangeReason(index, e.target.value, 'text')
                                }
                              />
                              {element.required &&
                                validateInput &&
                                (questions[index].reasonResponse?.[0] === undefined ||
                                  questions[index].reasonResponse[0]?.length < 3) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input cannot be less than 3!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.reasonType === 'number' && (
                            <div className='mb-3'>
                              <input
                                type='number'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder='Reason'
                                required={element.required}
                                value={questions[index].reasonResponse[0] ?? ''}
                                onChange={(e) =>
                                  handleInputChangeReason(index, e.target.value, 'number')
                                }
                              />
                              {element.required &&
                                validateInput &&
                                (questions[index].reasonResponse[0] === '' ||
                                  isNaN(questions[index].reasonResponse[0])) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input must be a valid number!
                                  </div>
                                )}
                            </div>
                          )}
                          {element.reasonType === 'checkbox' && (
                            <div className='ml-2 flex flex-col gap-1'>
                              {element.reasonOptions.map((currElem, idx) => (
                                <label key={idx} className='form-check-label'>
                                  <input
                                    type='checkbox'
                                    className='form-check-input me-3 mb-2'
                                    value={currElem}
                                    onChange={(e) =>
                                      setQuestions((prev) => {
                                        const updatedFormData = [...prev]
                                        if (e.target.checked) {
                                          updatedFormData[index] = {
                                            ...updatedFormData[index],
                                            reasonResponse: [
                                              ...updatedFormData[index].reasonResponse,
                                              e.target.value,
                                            ],
                                          }
                                        } else {
                                          updatedFormData[index] = {
                                            ...updatedFormData[index],
                                            reasonResponse: updatedFormData[
                                              index
                                            ].reasonResponse.filter(
                                              (item) => item !== e.target.value
                                            ),
                                          }
                                        }
                                        return updatedFormData
                                      })
                                    }
                                  />
                                  {currElem}
                                </label>
                              ))}
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    This option is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'multiple' && (
                            <div className='ml-2 flex flex-col gap-1'>
                              {element.reasonOptions.map((currElem, idx) => (
                                <label key={idx} className='form-check-label'>
                                  <input
                                    type='radio'
                                    name={`radio${index}`}
                                    className='form-check-input me-3 mb-2'
                                    required={element.required}
                                    value={currElem}
                                    onChange={(e) =>
                                      setQuestions((prev) => {
                                        const updatedFormData = [...prev]
                                        updatedFormData[index] = {
                                          ...updatedFormData[index],
                                          reasonResponse: [e.target.value],
                                        }
                                        return updatedFormData
                                      })
                                    }
                                  />
                                  {currElem}
                                </label>
                              ))}
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    This option is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'dropdown' && (
                            <div>
                              <select
                                className='form-select form-select-sm form-select-solid mb-2'
                                data-control='select2'
                                data-placeholder='Latest'
                                data-hide-search='true'
                                required={element.required}
                                defaultValue=''
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      reasonResponse: [e.target.value],
                                    }
                                    return updatedFormData
                                  })
                                }
                              >
                                <option value=''>Select</option>
                                {element.reasonOptions.map((currElem, idx) => (
                                  <option key={idx} value={currElem}>
                                    {currElem}
                                  </option>
                                ))}
                              </select>
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    This option is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'date' && (
                            <div>
                              <Flatpickr
                                className='form-control form-control-solid my-3'
                                placeholder='Reason'
                                required={element.required}
                                options={{
                                  dateFormat: 'd-m-Y',
                                }}
                                value={
                                  questions[index].reasonResponse
                                    ? new Date(questions[index].reasonResponse[0])
                                    : ''
                                }
                                onChange={(date) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      reasonResponse: [new Date(date).toISOString()],
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Date is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'time' && (
                            <div>
                              <Flatpickr
                                className='form-control form-control-solid my-3'
                                placeholder='Reason'
                                required={element.required}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: 'H:i',
                                  time_24hr: true,
                                }}
                                value={
                                  questions[index].reasonResponse
                                    ? new Date(questions[index].reasonResponse[0])
                                    : ''
                                }
                                onChange={(date) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      reasonResponse: [new Date(date).toISOString()],
                                    }
                                    return updatedFormData
                                  })
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'time-15' && (
                            <div>
                              <TimeIntervals
                                interval={15}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                                isReason={true}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'time-30' && (
                            <div>
                              <TimeIntervals
                                interval={30}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                                isReason={true}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'time-60' && (
                            <div>
                              <TimeIntervals
                                interval={60}
                                index={index}
                                questions={questions}
                                setQuestions={setQuestions}
                                isReason={true}
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Time is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'country' && (
                            <div>
                              <Select
                                options={countries}
                                onChange={(e) =>
                                  setQuestions((prev) => {
                                    const updatedFormData = [...prev]
                                    updatedFormData[index] = {
                                      ...updatedFormData[index],
                                      reasonResponse: [e?.value || ''],
                                    }
                                    return updatedFormData
                                  })
                                }
                                isClearable
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse.length < 1 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Country is required
                                  </div>
                                )}
                            </div>
                          )}

                          {element.reasonType === 'location' && (
                            <div>
                              <input
                                type='text'
                                className='form-control form-control-solid mb-3 mb-lg-0'
                                placeholder='Reason'
                                required={element.required}
                                value={questions[index].reasonResponse[0] ?? ''}
                                onChange={(e) =>
                                  handleInputChangeReason(index, e.target.value, 'text')
                                }
                              />
                              {element.required &&
                                validateInput &&
                                questions[index].reasonResponse[0]?.length < 3 && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    Input cannot be less than 3!
                                  </div>
                                )}
                              <div className='d-flex gap-2 my-3'>
                                <PlacesAutocomplete
                                  value={reasonLocationName[index]}
                                  onChange={(value) =>
                                    setReasonLocationName((prev) => {
                                      const updatedLocationName = [...prev]
                                      updatedLocationName[index] = value
                                      return updatedLocationName
                                    })
                                  }
                                  onSelect={(value) => handleReasonSelect(value, index)}
                                  searchOptions={{
                                    location: new google.maps.LatLng(25.276987, 55.296249),
                                    radius: 300000,
                                    componentRestrictions: {country: 'ae'},
                                  }}
                                >
                                  {({
                                    getInputProps,
                                    suggestions,
                                    getSuggestionItemProps,
                                    loading,
                                  }) => (
                                    <div className='flex-grow-1'>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Search Location...',
                                          className:
                                            'location-search-input form-control form-control-solid',
                                        })}
                                      />
                                      <div className='autocomplete-dropdown-container'>
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion) => (
                                          <div
                                            {...getSuggestionItemProps(suggestion, {
                                              className: suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item',
                                            })}
                                            key={suggestion.placeId}
                                            className='cursor-pointer form-control form-control-solid'
                                          >
                                            <span>{suggestion.description}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                              </div>
                              {element.required &&
                                validateInput &&
                                (!questions[index].reasonResponse ||
                                  questions[index].reasonResponse.length === 0) && (
                                  <div className='alert alert-danger mt-2' role='alert'>
                                    At least one location is required!
                                  </div>
                                )}
                            </div>
                          )}
                        </>
                      )
                    }

                    function renderRankQuestions(data, questionNumber) {
                      return (
                        <div className='space-y-6'>
                          {data?.map((element, subIndex) => {
                            const idx = element.originalIndex
                            return (
                              <div
                                key={`rank-${subIndex}`}
                                className='border-l-4 border-blue-500 pl-3 sm:pl-6 py-3 mb-4'
                              >
                                <p className='text-sm sm:text-base font-medium mb-4 text-gray-800 leading-relaxed'>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: parseBold(element.question),
                                    }}
                                  />{' '}
                                  {element.required && (
                                    <span className='text-red-600 text-lg'>*</span>
                                  )}
                                </p>

                                <div className='flex gap-2 sm:gap-3 flex-wrap w-100'>
                                  {element?.options?.map((option, optIndex) => {
                                    const isSelected = questions[idx]?.response?.[0] === option
                                    return (
                                      <label
                                        key={`option-${optIndex}`}
                                        className={`min-w-[60px] sm:min-w-[80px] h-[60px] sm:h-[80px] flex items-center justify-center cursor-pointer rounded-lg border-2 transition-all flex-1 sm:flex-initial ${
                                          isSelected ? 'bg-primary' : 'bg-hover-light-primary'
                                        } ${option.length > 3 ? 'px-2 sm:px-3' : ''}`}
                                      >
                                        <input
                                          type='radio'
                                          className='hidden'
                                          name={`question-${idx}`}
                                          value={option}
                                          checked={isSelected}
                                          onChange={(e) => {
                                            setQuestions((prev) => {
                                              const updatedFormData = [...prev]
                                              updatedFormData[idx] = {
                                                ...updatedFormData[idx],
                                                response: [e.target.value],
                                              }
                                              return updatedFormData
                                            })
                                          }}
                                        />
                                        <span
                                          className={`font-semibold ${
                                            option.length > 3
                                              ? 'text-base sm:text-lg'
                                              : 'text-xl sm:text-2xl'
                                          }`}
                                        >
                                          {option}
                                        </span>
                                      </label>
                                    )
                                  })}
                                </div>

                                {element.required &&
                                  validateInput &&
                                  questions[idx].response.length < 1 && (
                                    <div className='alert alert-danger mt-3' role='alert'>
                                      This question is required
                                    </div>
                                  )}
                              </div>
                            )
                          })}
                        </div>
                      )
                    }

                    // function handleCheckpointValueChange(e, index) {
                    //   setQuestions((prev) => {
                    //     const updatedFormData = [...prev]
                    //     updatedFormData[index] = {
                    //       ...updatedFormData[index],
                    //       response: [e.target.value],
                    //     }
                    //     return updatedFormData
                    //   })

                    //   const temp = sectionOptions.find((option) => option.option === e.target.value)
                    //   // create range of skipped questions
                    //   // const skippedQuestions = Array.from(
                    //   //   {length: temp.to - temp.from + 1},
                    //   //   (_, i) => temp.from + i
                    //   // )
                    //   // setSkippedQuestionsIndex(skippedQuestions)
                    //   const questionsLeft = Array.from(
                    //     {
                    //       length: tempOrdersList[tempOrdersList.length - 1] - checkpointIndex - 1,
                    //     },
                    //     (_, i) => i + checkpointIndex + 1
                    //   )
                    //   const skippedQuestions = questionsLeft.filter(
                    //     (question) => question >= temp.from && question <= temp.to
                    //   )
                    //   let quesIndex = 1
                    //   const totalQuestionsWithGrouped = data.reduce((acc, curr, i) => {
                    //     // group questions having same title
                    //     if (acc[curr.title]) {
                    //       acc[curr.title].push(i)
                    //     } else {
                    //       acc[curr.title] = [i]
                    //     }
                    //     return acc
                    //   }, {})
                    //   const length =
                    //     Object.keys(totalQuestionsWithGrouped).length +
                    //     totalQuestionsWithGrouped?.['undefined']?.length -
                    //     1
                    //   const questionNumberLists = Array.from({length: length}, (_, i) => 0)
                    //   for (let i = 0; i < length; i++) {
                    //     if (i <= checkpointIndex) {
                    //       questionNumberLists[i] = quesIndex
                    //       quesIndex++
                    //     } else {
                    //       const hasQuestion = skippedQuestions.includes(i + 1)
                    //       if (hasQuestion) {
                    //         questionNumberLists[i] = quesIndex
                    //         quesIndex++
                    //       }
                    //     }
                    //   }
                    //   setQuestionNumberList(questionNumberLists)
                    //   setSkippedQuestionsIndex(skippedQuestions)
                    // }

                    function renderCheckpointQuestionInput(element: QuestionData, index: number) {
                      const currentCheckpoint = checkpoints.find(
                        (cp) => cp.index === element.order - 1
                      )
                      const optionsToRender = currentCheckpoint
                        ? currentCheckpoint.sectionOptions
                        : []

                      return (
                        <div className='ml-2 flex flex-col gap-2'>
                          <div
                            className={element.options.length > 6 ? 'row' : 'flex flex-col gap-2'}
                          >
                            {optionsToRender.map((currElem, idx) => (
                              <label
                                key={idx}
                                className={`form-check-label text-base cursor-pointer p-3 rounded-lg border transition-all ${
                                  questions[index].response[0] === currElem.option
                                    ? 'bg-light-primary border-primary shadow-md'
                                    : 'border-secondary border-hover-primary'
                                } ${element.options.length > 5 ? 'col-md-6' : ''}`}
                              >
                                <input
                                  type='radio'
                                  name={`radio${index}`}
                                  className='form-check-input me-3 border-gray-300'
                                  required={element.required}
                                  value={currElem.option}
                                  checked={questions[index].response[0] === currElem.option}
                                  onChange={(e) =>
                                    handleCheckpointValueChange(
                                      e as React.ChangeEvent<HTMLInputElement>,
                                      index
                                    )
                                  }
                                />
                                {currElem.option}
                              </label>
                            ))}
                            {element.required &&
                              validateInput &&
                              questions[index].response.length < 1 && (
                                <div className='alert alert-danger mt-2' role='alert'>
                                  This option is required
                                </div>
                              )}
                          </div>
                        </div>
                      )
                    }
                  })()}
                </div>
                <div className='mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200'>
                  <button
                    type='button'
                    onClick={handleFormSubmit}
                    disabled={submitting}
                    className='btn btn-primary uppercase px-6 sm:px-8 py-2 sm:py-3 text-base sm:text-lg font-semibold hover:shadow-xl transition-shadow w-full sm:w-auto'
                  >
                    {submitting ? <Spinner animation='border' size='sm' /> : 'Submit Interview'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <Modal show={showModal} onHide={closeModal} size='lg' backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>Choose your Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='card-body py-4'>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={14}
                onClick={(e) => {
                  handleMapClick(e)
                }}
              >
                {coordinates && <Marker position={coordinates}></Marker>}
              </GoogleMap>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={saveLocation}>
              Save
            </Button>
            <Button variant='danger' onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  )
}

export default InterviewQuestionaire
